var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8314 21.3334C29.8314 19.8614 31.026 18.6667 32.498 18.6667C33.97 18.6667 35.1647 19.8614 35.1647 21.3334V34.6667C35.1647 36.1388 33.97 37.3334 32.498 37.3334C31.026 37.3334 29.8314 36.1388 29.8314 34.6667V21.3334ZM29.8314 42.6667C29.8314 41.1947 31.026 40.0001 32.498 40.0001C33.97 40.0001 35.1647 41.1947 35.1647 42.6667C35.1647 44.1387 33.97 45.3334 32.498 45.3334C31.026 45.3334 29.8314 44.1387 29.8314 42.6667ZM32.4987 53.3335C20.736 53.3335 11.1654 43.7628 11.1654 32.0002C11.1654 20.2375 20.736 10.6668 32.4987 10.6668C44.2614 10.6668 53.832 20.2375 53.832 32.0002C53.832 43.7628 44.2614 53.3335 32.4987 53.3335ZM32.4987 5.3335C17.7707 5.3335 5.83203 17.2722 5.83203 32.0002C5.83203 46.7282 17.7707 58.6668 32.4987 58.6668C47.2267 58.6668 59.1654 46.7282 59.1654 32.0002C59.1654 17.2722 47.2267 5.3335 32.4987 5.3335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/AlertCircle.57cb4519c5145368da0b87d13c67d3a0.svg";
export { ForwardRef as ReactComponent };